<template>
	<div>
		<sky-upload-img
			v-if="getFileList.length"
			:disabled="true"
			:readOnly="true"
			:value="getFileList"
		></sky-upload-img>
		<i v-else>-</i>
	</div>
</template>

<script>
import skyUploadImg from 'sky-upload';
export default {
	props: ['tableData', 'scope'],
	components: {
		skyUploadImg,
	},
	computed: {
		getFileList() {
			if (Array.isArray(this.scope.row[this.tableData.bind])) {
				return this.scope.row[this.tableData.bind];
			} else {
				return this.scope.row[this.tableData.bind] ? [this.scope.row[this.tableData.bind]] : [];
			}
		},
	},
	data() {
		return {};
	},
};
</script>

<style lang="scss" scoped></style>
